import {registerComponent} from '../utils/registry';

export default class Collapse {
    /**
     * Toggles visibility of a collapsible element.
     * @param button The clicked button element
     * @param elementToCollapse The id of the collapsible element
     */
    public toggle(button: HTMLElement, elementToCollapse: string): void {
        const answer = document.getElementById(elementToCollapse);
        if (!answer) {
            console.error("Could not find the element to collapse: #" + elementToCollapse);
            return;
        }

        const expanded = button.getAttribute('aria-expanded') === 'true';
        const isOpening = !expanded;

        button.setAttribute('aria-expanded', String(isOpening));

        if (isOpening) {
            const scrollHeight = `${answer.scrollHeight}px`;
            answer.style.maxHeight = scrollHeight;
            answer.classList.add('open');
        } else {
            // Collapse smoothly
            answer.style.maxHeight = `${answer.scrollHeight}px`;
            void answer.offsetHeight; // force reflow for transition
            answer.style.maxHeight = '0';
            answer.classList.remove('open');
        }

        // toggle arrow visibility if they exist
        const upArrow = button.querySelector('.arrow-up') as HTMLElement | null;
        const downArrow = button.querySelector('.arrow-down') as HTMLElement | null;
        if (upArrow && downArrow) {
            upArrow.style.display = expanded ? 'none' : 'inline-block';
            downArrow.style.display = expanded ? 'inline-block' : 'none';
        }
    }
}

registerComponent('collapse', new Collapse());
